import { render, staticRenderFns } from "./CoupnEditor.vue?vue&type=template&id=047e383a"
import script from "./CoupnEditor.vue?vue&type=script&lang=js"
export * from "./CoupnEditor.vue?vue&type=script&lang=js"
import style0 from "./CoupnEditor.vue?vue&type=style&index=0&id=047e383a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports